module.exports = __webpack_public_path__ + "img/delete-dialogues-icon.2930785a.svg";